import { render, staticRenderFns } from "./netbarSoftware.vue?vue&type=template&id=287b03fd&scoped=true&"
import script from "./netbarSoftware.vue?vue&type=script&lang=js&"
export * from "./netbarSoftware.vue?vue&type=script&lang=js&"
import style0 from "./netbarSoftware.vue?vue&type=style&index=0&id=287b03fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287b03fd",
  null
  
)

export default component.exports